import {
	createRouter,
	createWebHashHistory
} from "vue-router";
const home = () => import("../pages/home")
const login = () => import("../pages/login")
const culture = () => import("../pages/culture")
const about = () => import("../pages/about")
const news = () => import("../pages/news")
const detail = () => import("../pages/detail")
const product = () => import("../pages/product")
const contact = () => import("../pages/contact.vue")
const honor = () => import("../pages/honor.vue")
const routes = [{
		path: "/",
		redirect: "/home"
	},
	{
		path: "/home",
		name: "home",
		component: home
	},
	{
		path: "/culture",
		name: "culture",
		component: culture
	},
	{
		path: "/about",
		name: "about",
		component: about
	},
	{
		path: "/news",
		name: "news",
		component: news
	},
	{
		path: "/detail",
		name: "detail",
		component: detail
	},
	{
		path: "/product",
		name: "product",
		component: product
	},
	{
		path: '/contact',
		name: 'contact',
		component: contact
	},
	{
		path: '/honor',
		name: 'honor',
		component: honor
	}
]

const router = createRouter({
	history: createWebHashHistory(),
	routes: routes,
	scrollBehavior() {
		// vue2.0  x  y  控制
		// vue3.0  left  top 控制
		return {
			left: 0,
			top: 0
		}
	}
})

export default router